import { render, staticRenderFns } from "./ModalFechamento.vue?vue&type=template&id=725adb46"
import script from "./ModalFechamento.vue?vue&type=script&lang=js"
export * from "./ModalFechamento.vue?vue&type=script&lang=js"
import style0 from "./ModalFechamento.vue?vue&type=style&index=0&id=725adb46&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports